import { CODE, STATE } from './constants';

export const checkIsUrlIntermediateUrl = () => {
  const currentUrl = window.location.href;
  if (currentUrl.includes(CODE) && currentUrl.includes(STATE)) {
    return true;
  }
  return false;
};

export const validateToken = async (url: string, token: string) => {
  try {
    const method = 'POST';
    const headers = { Authorization: `Bearer ${token}` };
    const response = await fetch(url, { method, headers });
    const data = await response.json();
    const statusCode = response.status;
    return {
      statusCode: statusCode,
      jsonData: data,
    };
  } catch (exception) {
    return {
      statusCode: null,
      jsonData: null,
      error: true,
    };
  }
};
